import { OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UITabModel, UIFieldSetModel } from 'e5core-angular-services';

export class E5coreUiWorkTabBaseComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() tab: UITabModel ;
  @Input() fieldSetIds: number[] ;

  constructor() { }

  ngOnInit() {
  }

}
